import script from "./PersonComp2.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonComp2.vue?vue&type=script&setup=true&lang=js"

import "./PersonComp2.vue?vue&type=style&index=0&id=2eeb9583&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eeb9583"]])

export default __exports__